var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "店铺名称" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.sellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "sellerId", $$v)
                        },
                        expression: "searchInfo.sellerId"
                      }
                    },
                    _vm._l(_vm.sellerOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "专区名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "搜索条件", clearable: "" },
                    model: {
                      value: _vm.searchInfo.showAreaName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "showAreaName", $$v)
                      },
                      expression: "searchInfo.showAreaName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属类目" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.categoryNo,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "categoryNo", $$v)
                        },
                        expression: "searchInfo.categoryNo"
                      }
                    },
                    _vm._l(_vm.categoryOptions, function(item) {
                      return _c("el-option", {
                        key: item.categoryNo,
                        attrs: { label: item.name, value: item.categoryNo }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "为您推荐" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "搜索条件" },
                      model: {
                        value: _vm.searchInfo.isRecommend,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "isRecommend", $$v)
                        },
                        expression: "searchInfo.isRecommend"
                      }
                    },
                    [
                      _c("el-option", {
                        key: 1,
                        attrs: { label: "是", value: 1 }
                      }),
                      _c("el-option", {
                        key: 2,
                        attrs: { label: "否", value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.searchInfo.showAreaStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "showAreaStatus", $$v)
                        },
                        expression: "searchInfo.showAreaStatus"
                      }
                    },
                    [
                      _c(
                        "el-option",
                        { key: 5, attrs: { label: "启用", value: 5 } },
                        [_vm._v("启用")]
                      ),
                      _c(
                        "el-option",
                        { key: 6, attrs: { label: "禁用", value: 6 } },
                        [_vm._v("禁用")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSearch } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
                    [_vm._v("新增")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "tooltip-effect": "dark",
            height: "calc(100vh - 25rem)"
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", prop: "ID" }
          }),
          _c("el-table-column", {
            attrs: { label: "店铺名称", prop: "sellerId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("getSellerName")(scope.row.sellerId)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "专区头图",
              align: "center",
              "header-align": "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-image", {
                      attrs: {
                        src: scope.row.showAreaImgUrl,
                        fit: "contain",
                        "preview-src-list": [scope.row.showAreaImgUrl]
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "专区名称", prop: "showAreaName" }
          }),
          _c("el-table-column", {
            attrs: { label: "所属类目", prop: "categoryName" }
          }),
          _c("el-table-column", {
            attrs: { label: "背景色" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", {
                      staticClass: "area-bgcolor",
                      style: "background-color:" + scope.row.backgroudColor
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { label: "排序", prop: "weight" } }),
          _c("el-table-column", {
            attrs: { label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.showAreaStatus == 5
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [_vm._v("已启用")]
                        )
                      : _vm._e(),
                    scope.row.showAreaStatus == 6
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              effect: "plain"
                            }
                          },
                          [_vm._v("已禁用")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "创建时间" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.CreatedAt)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("变更")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onUpdateStatus(scope.row, 5)
                          }
                        }
                      },
                      [_vm._v("启用")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onUpdateStatus(scope.row, 6)
                          }
                        }
                      },
                      [_vm._v("禁用")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "danger" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }